import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

type IconVariant = 'dark' | 'light' | 'white' | 'coloredLight' | 'coloredDark';

interface Props {
  variant: IconVariant;
}

const mainPathColor: { [Variant in IconVariant]: string } = {
  dark: '#323232',
  light: '#B8C7CE',
  white: '#FFF',
  coloredLight: '#FAA529',
  coloredDark: '#FAA529',
};

const sourceTargetColor: { [Variant in IconVariant]: string } = {
  dark: '#323232',
  light: '#B8C7CE',
  white: '#FFF',
  coloredLight: '#66B2FF',
  coloredDark: '#66B2FF',
};

const otherElementsColor: { [Variant in IconVariant]: string } = {
  dark: '#323232',
  light: '#B8C7CE',
  white: '#FFF',
  coloredLight: '#FFF',
  coloredDark: '#323232',
};

const BarePathlookupIcon: FC<SvgWrapperProps & Props> = ({
  variant,
  ...props
}) => (
  <SvgWrapper height='20' viewBox='0 0 20 20' width='20' {...props}>
    {}
    <polygon
      fillRule='evenodd'
      clipRule='evenodd'
      fill={mainPathColor[variant]}
      points='16,10 16,8 5,8 5,4 4,4 4,9 15,9 15,10 13,10 15.5,12 18,10 '
    />
    {}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      fill={otherElementsColor[variant]}
      d='M12.5,1C11.1,1,10,2.1,10,3.5c0,1.2,0.9,2.2,2,2.4V7h1V5.9 c1.1-0.2,2-1.2,2-2.4C15,2.1,13.9,1,12.5,1z M12.5,5C11.7,5,11,4.3,11,3.5S11.7,2,12.5,2C13.3,2,14,2.7,14,3.5S13.3,5,12.5,5z M8,13.1v-3H7v3c-1.1,0.2-2,1.2-2,2.4C5,16.9,6.1,18,7.5,18c1.4,0,2.5-1.1,2.5-2.5C10,14.3,9.1,13.3,8,13.1z M7.5,17 C6.7,17,6,16.3,6,15.5S6.7,14,7.5,14C8.3,14,9,14.7,9,15.5S8.3,17,7.5,17z'
    />
    {}
    <path
      fill={sourceTargetColor[variant]}
      d='M15.5,13c-1.4,0-2.5,1.1-2.5,2.5c0,1.4,1.1,2.5,2.5,2.5c1.4,0,2.5-1.1,2.5-2.5C18,14.1,16.9,13,15.5,13z M4.5,1C3.1,1,2,2.1,2,3.5C2,4.9,3.1,6,4.5,6C5.9,6,7,4.9,7,3.5C7,2.1,5.9,1,4.5,1z'
    />
  </SvgWrapper>
);
export const PathlookupIcon = memo(BarePathlookupIcon);
